<template>
  <modal :show="show" @change="$emit('change', $event)" width="550">
    <template v-slot:header>
      <span>Уважаемый клиент!</span>
    </template>
    <template v-slot:main>
      <div  class="modal-info text-center mx-7 mt-10">
        <span class="d-block my-5">
          Сервис оплаты временно недоступен. Пожалуйста, повторите попытку
          позже.
        </span>
        <v-btn @click="$emit('change', false)" class="orange-button mb-5 mt-5" :loading="loading"
          >Закрыть
        </v-btn>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "../common/Modal";
import { mask } from "vue-the-mask";

export default {
  name: "ModalPayment",
  directives: {
    mask,
  },
  components: {
    Modal,
  },
  model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: false,
    valid: false,
  }),
  computed: {
  },
  methods: {
    Close() {
      this.$router.push("/");
    },
  },
  created() {

  },
  watch: {

  },
  mounted() {
  },
};
</script>

<style lang="scss">
.modal-info {
  min-height: 200px;
  //display: flex;
  //flex-direction: column;

  &__message {
    margin: auto;
  }
}

.orange--checkbox {
  color: green !important;

  .accent--text {
    i {
      color: green !important;
    }
  }

  .v-application .accent--text {
    color: green !important;
  }
}

.modalPayment__form-item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  width: 100%;

  .modalPayment__form-checkbox {
    position: relative;
    height: max-content;
    padding: 5px 0 0 0;
  }

  .modalPayment__form-field {
    position: relative;
    width: calc(100% - 32px);
    height: max-content;
  }

  .commission {
    margin-left: 2110px;
    padding-left: 1000px;
  }
}
